import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Button } from "../../../../../stories/Button/Button";
import { MaterialRequestStatus } from "../../../../../utils/Enum.types";
import { AppContext } from "./statesProvider/materialContext";
import MultiSelectSupplier from "./MultiSelectSupplier";
import { materialStatesPayloadTypes } from "./statesProvider/materialReducer";
import { responseType } from "../../../../../utils/formTypes";
import useLabels from "../../../../../customHooks/useLabels";
import { LdgrQueryType } from "../../masters/supplier/queries/types";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: MaterialRequestStatus;
  handleClose: () => void;
  value?: responseType[];
  handleItemSelect?: (newValue: responseType[]) => void;
}
const SelectedSuppliers = ({
  setModalFlag,
  pageType,
  handleClose,
  handleItemSelect,
  value,
}: Props) => {
  const { state, dispatch } = useContext(AppContext);

  const [selectedSuppliers, setSelectedSuppliers] = useState<responseType[]>(
    []
  );
  const { ledgerLabel } = useLabels();
  const handleDelete = (id: number) => {
    const filterSuppliers = selectedSuppliers.filter(
      ({ value }) => value !== id
    );
    setSelectedSuppliers(filterSuppliers);
  };

  useEffect(() => {
    if (value) {
      setSelectedSuppliers(value);
    } else setSelectedSuppliers(state.selectedSuppliers);
  }, [state.selectedSuppliers]);

  const handleSave = () => {
    if (handleItemSelect) {
      handleItemSelect(selectedSuppliers);
    } else {
      dispatch({
        type: materialStatesPayloadTypes.SUPPLIERS,
        payload: {
          selectedSuppliers: selectedSuppliers,
        },
      });
    }

    handleClose();
  };

  return (
    <>
      <div className="material-selected-supplier">
        <div className="material-selected-supplier__title">
          <Title>Selected {ledgerLabel} List</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        {state.itm ? (
          <div className="material-selected-supplier__flex">
            <b>{state.itm.label}</b>
            {state.itm.code ? <span>( {state.itm.code} )</span> : null}
          </div>
        ) : null}
        {pageType === MaterialRequestStatus.PENDING ? null : (
          <MultiSelectSupplier
            onChange={(newValue) => {
              setSelectedSuppliers(newValue);
            }}
            autoCompleteValue={selectedSuppliers}
            handleClear={() => {}}
            onKeyDown={(e) => {}}
            input={{
              itemID: 0,
              query_type: LdgrQueryType.ALL,
              tableLevel: undefined,
            }}
          />
        )}

        <div
          className={`material-selected-supplier__block${
            pageType === MaterialRequestStatus.PENDING ? "--pending" : ""
          }`}
        >
          <div className="material-selected-supplier__block--header">
            <b>Selected {ledgerLabel}</b>
            <span>{selectedSuppliers.length}</span>
          </div>
          <div className="material-selected-supplier__block--list">
            {selectedSuppliers.map((supp) => {
              return (
                <span>
                  {supp.label}
                  {pageType === MaterialRequestStatus.PENDING ? null : (
                    <img
                      src={Close}
                      alt=""
                      onClick={() => {
                        handleDelete(supp.value);
                      }}
                    />
                  )}
                </span>
              );
            })}
          </div>
        </div>
        <Button mode="save" onClick={handleSave} />
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default SelectedSuppliers;
